import React, { useEffect } from "react";
import styled from "styled-components";
import { KEY_ENTER, KEY_ESC } from "../../../../lib";
import { hideToolbar } from "./commands";

const Input = styled.input.attrs({
    type: "text",
})<{
    textAlign: string;
    enableDarkTheme?: boolean;
}>`
    outline: none;
    direction: ltr;
    text-align: ${(p) => p.textAlign};
    margin: 0 0 3px 0;
    border: 0;
    width: ${(p) => p.width}px;
    height: 30px;
    line-height: 30px;
    font-family: "Source Code Pro", monospace;
    border-bottom: 1px solid ${(p) => (p.enableDarkTheme ? "#000" : "#fff")};
    color: ${(p) => (p.enableDarkTheme ? "#000" : "#fff")};
    background-color: transparent;
    font-size: 14px;

    &::placeholder {
        direction: rtl;
        font-family: urdu;
        font-weight: 500;
        color: ${(p) => (p.enableDarkTheme ? "#333" : "#e6e6e6")};
    }
`;

type Props = {
    value?: string;
    width: number;
    textAlign?: string;
    enableDarkTheme?: boolean;
    placeholder: string;
    onClick: (value: string) => void;
};

export default function TextField(props: Props) {
    const { width, textAlign, enableDarkTheme, placeholder } = props;
    const fieldRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        const f = fieldRef;
        if (f && f.current) {
            f.current.value = props.value || "";
            f.current.focus();
        }
    }, [fieldRef, props.value]);

    const onKeyUp = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if (evt.key === KEY_ENTER) {
            props.onClick((evt.target as HTMLInputElement).value);
            evt.preventDefault();
            return false;
        } else if (evt.key === KEY_ESC) {
            hideToolbar();
        }
    };

    return (
        <Input
            ref={fieldRef}
            placeholder={placeholder}
            width={width}
            textAlign={textAlign || "right"}
            onKeyUp={onKeyUp}
            enableDarkTheme={enableDarkTheme}
        />
    );
}
